import * as React from "react"
import CircularProgress from "@mui/material/CircularProgress"
import Box from "@mui/material/Box"
import { Dialog } from "@mui/material"

export default function Loading({ isLoading }) {
	return (
		<Dialog open={isLoading}>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					padding: "20px",
				}}
			>
				<CircularProgress color="secondary" />
			</div>
		</Dialog>
	)
}
